(function () {
  'use strict';

  class Tooltip {
    constructor() {
      this.el = document.createElement('div');
      this.el.className = 'tc-tooltip';
      this.el.setAttribute('role', 'tooltip');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.appendChild(this.el);
      this._raf = null;
      this._x = 0;
      this._y = 0;
    }
    show(text, x, y) {
      this.el.textContent = text;
      this.el.classList.add('tc-tooltip--visible');
      this._moveTo(x, y);
    }
    move(x, y) {
      this._x = x; this._y = y;
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        this._moveTo(this._x, this._y);
      });
    }
    hide() {
      this.el.classList.remove('tc-tooltip--visible');
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
    }
    _moveTo(x, y) {
      this.el.style.transform = `translate(${x + 14}px,${y - 36}px)`;
    }
    destroy() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this.el.remove();
    }
  }

  function initSkeletons(items) {
    items.forEach(item => {
      const img = item.querySelector('.collection-image');
      if (!img) return;
      item.classList.add('tc-skeleton');
      if (img.complete && img.naturalWidth) {
        item.classList.remove('tc-skeleton');
        return;
      }
      img.addEventListener('load',  () => item.classList.remove('tc-skeleton'), { once: true });
      img.addEventListener('error', () => item.classList.remove('tc-skeleton'), { once: true });
    });
  }

  class TechCollectionCarousel {
    constructor(section) {
      this.section   = section;
      this.id        = section.dataset.sectionId;
      this.track     = section.querySelector('#tech-track-' + this.id);
      this.viewport  = section.querySelector('.tech-viewport');
      this.toggleBtn = section.querySelector('[data-tc-toggle]');
      this.items     = this.track ? Array.from(this.track.children) : [];
      this._cleanups = [];
      this._tooltip  = new Tooltip();
      this.hidden    = false;
    }

    init() {
      if (!this.track || !this.items.length) return;
      initSkeletons(this.items);
      this._bindTooltips();
      this._bindToggle();
    }

    destroy() {
      this._cleanups.forEach(fn => fn());
      this._cleanups = [];
      this._tooltip.destroy();
      delete this.section._tc;
    }

    toggleVisibility() {
      this.hidden = !this.hidden;
      if (this.viewport) this.viewport.classList.toggle('tc-viewport--hidden', this.hidden);
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', String(!this.hidden));
    }

    _on(el, ev, fn, opts) {
      if (!el) return;
      el.addEventListener(ev, fn, opts);
      this._cleanups.push(() => el.removeEventListener(ev, fn, opts));
    }

    _bindTooltips() {
      this.items.forEach(item => {
        const link  = item.querySelector('.collection-link');
        const titleEl = item.querySelector('.collection-title');
        const title = titleEl && titleEl.textContent && titleEl.textContent.trim();
        if (!link || !title) return;
        this._on(link, 'mouseenter', e => this._tooltip.show(title, e.clientX, e.clientY));
        this._on(link, 'mousemove',  e => this._tooltip.move(e.clientX, e.clientY));
        this._on(link, 'mouseleave', ()  => this._tooltip.hide());
      });
    }

    _bindToggle() {
      this._on(this.toggleBtn, 'click', () => this.toggleVisibility());
    }
  }

  function mount(section) {
    if (section._tc) return;
    const c = new TechCollectionCarousel(section);
    c.init();
    section._tc = c;
  }

  function unmount(section) {
    if (section._tc) {
      section._tc.destroy();
      section._tc = null;
    }
  }

  function observeAll() {
    /* Use [data-tc-section] — unique to this component.
       Avoids collisions with Dawn's own [data-section-id] which is present
       on ALL Shopify section wrapper elements across the theme. */
    const sections = document.querySelectorAll('[data-tc-section]');
    if (!sections.length) return;

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          mount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    sections.forEach(function (s) { io.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll, { once: true });
  } else {
    observeAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = document.querySelector('[data-tc-section][data-section-id="' + e.detail.sectionId + '"]');
      if (!s) return;
      unmount(s);
      setTimeout(function () { mount(s); }, 100);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var s = document.querySelector('[data-tc-section][data-section-id="' + e.detail.sectionId + '"]');
      if (s) unmount(s);
    });
  }

}());
